
import { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useHttpClient } from '../../../shared/http-client';
import { useDrawer } from '../../../shared/drawer';
import { useStore } from '../../../shared/store';
import { PageBody } from '../../../elements/page-body';
//import { InventarioForm } from './inventario-form';
import { Button } from '../../../elements/button';
import { Table } from '../../../elements/table';


export const UpdateCustomers = () => {
    const { open, close } = useDrawer();
    const { get, set } = useStore();
    const navigate = useNavigate();
    const { api, state, options } = useHttpClient();
    const { t } = useTranslation() as { t: (key: string) => string };
    const [prospectionSearches, setProspectionSearches] = useState<any | null>([]);
    const [selectedProspectionSearches, setSelectedProspectionSearches] = useState<any | null>(null);
    const [selectedIndexProspectionSearches, setSelectedIndexProspectionSearches] = useState<number | null>(null);
    const [citySearch, setCitySearch] = useState<string>('');
    const [searchDealerships, setSearchDealerships] = useState<boolean>(false);
    const [searchWorkshops, setSearchWorkshops] = useState<boolean>(false);
    const [searchSpareParts, setSearchSpareParts] = useState<boolean>(false);
    const [searchRentACar, setSearchRentACar] = useState<boolean>(false);
    const [searchMotorcycleSales, setSearchMotorcycleSales] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<string | null>(null);
    
    // Status filter (radio button)
    const [statusFilter, setStatusFilter] = useState<string>('ALL');
    
    // Ref for results table
    const resultsTableRef = useRef<HTMLDivElement>(null);
    
    // Ref for import results table
    const importResultsTableRef = useRef<HTMLDivElement>(null);
    
    // Selected rows for import
    const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());
    
    // Delete unimported flag
    const [deleteUnimported, setDeleteUnimported] = useState<boolean>(false);
    
    // Import results
    const [importResults, setImportResults] = useState<any | null>(null);

    // Build query string for status filter and ordering
    const buildStatusQuery = () => {
        const params: string[] = [];
        
        // Add ordering
        params.push('ordering=started_at');
        
        // Add status filter if not ALL
        if (statusFilter !== 'ALL') {
            params.push(`status=${statusFilter}`);
        }
        
        return params.join('&');
    };

    // Update refresh when filter changes to reload table
    useEffect(() => {
        setRefresh(Date.now().toString());
    }, [statusFilter]);


    const handleClick = (item: any, index: any) => {
        setSelectedIndexProspectionSearches(index);
        setSelectedRows(new Set()); // Clear selection when loading new results

        api(`/fleet/prospection-results/?search=${item.id}`, 'GET');
        
        // Scroll to results table after a short delay to ensure data is loaded
        setTimeout(() => {
            resultsTableRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
    };
    
    // Toggle individual row selection
    const handleRowSelect = (index: number) => {
        const newSelected = new Set(selectedRows);
        if (newSelected.has(index)) {
            newSelected.delete(index);
        } else {
            newSelected.add(index);
        }
        setSelectedRows(newSelected);
    };
    
    // Toggle all rows selection
    const handleSelectAll = () => {
        if (selectedRows.size === selectedProspectionSearches?.results?.length) {
            setSelectedRows(new Set());
        } else {
            const allIndexes = new Set<number>(selectedProspectionSearches?.results?.map((_: any, index: number) => index));
            setSelectedRows(allIndexes);
        }
    };
    
    // Handle import button click
    const handleImport = () => {
        const selectedItems = selectedProspectionSearches?.results?.filter((_: any, index: number) => selectedRows.has(index));

        const obj = {
            result_ids: selectedItems?.map((item: any) => item.id),
            delete_unimported: deleteUnimported
        }

        api(`/fleet/prospection-results/import_to_customers/`, 'POST', obj);
    };

    const handleSearch = () => {
        if (!citySearch.trim()) {
            toast.error(t('common.label.poblacion') + ' ' + t('common.message.required'));
            return;
        }

        // Convert comma-separated cities to array
        const citiesArray = citySearch
            .split(',')
            .map(city => city.trim())
            .filter(city => city.length > 0);

        const obj = {
            cities: citiesArray,
            //cities: citySearch.trim(),
            search_dealerships: searchDealerships,
            search_workshops: searchWorkshops,
            search_spare_parts: searchSpareParts,
            search_rent_a_car: searchRentACar,
            search_motorcycle_sales: searchMotorcycleSales
        }
        api(`/fleet/prospection-searches/`, 'POST', obj);
    };

    const handleClearSearch = () => {
        setCitySearch('');
        setSearchDealerships(true);
        setSearchWorkshops(true);
        setSearchSpareParts(false);
        setSearchRentACar(true);
        setSearchMotorcycleSales(false);
        setProspectionSearches([]);
        setSelectedProspectionSearches(null);
        setSelectedIndexProspectionSearches(null);
    };

    /*     const handleGo = (value: any) => {
            navigate(`/stock/conteo-de-stock`, { state: { value } })
        }; */


    // Handle API responses
    useEffect(() => {
        if (state.data) {

            if (state.path.includes('prospection-searches')) {
                if (state.method === 'POST') {
                    //api(`/fleet/prospection-searches/${state.data.id}`, 'GET');
                    api(`/fleet/prospection-searches`, 'GET');

                }
                if (state.method === 'GET') {
                    setProspectionSearches(state.data.results || []);

                }

            }
            if (state.path.includes('prospection-results')) {
                if (state.method === 'GET') {
                    setSelectedProspectionSearches(state.data || null);
                }

            }
             if (state.path.includes('import_to_customers')) {
                if (state.method === 'POST') {
                    console.log('state.data', state.data)
                    setImportResults(state.data);
                    setSelectedRows(new Set()); // Clear selection after import
                    
                    // Scroll to import results table after a short delay
                    setTimeout(() => {
                        importResultsTableRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }, 300);
                }

            }

        }

        if (state.error) {

        }
    }, [state]);




    return (
        <PageBody
            title={'common.label.actualizacion-clientes'}
        >
            <>
                <div className="mb-6 bg-white rounded-lg shadow-md border border-gray-200 p-6">
                    <div className="flex gap-2 items-end justify-between">
                        <div className="w-full max-w-md">
                            <label className="block text-sm font-semibold text-gray-700 mb-1">
                                {t('common.label.poblacion')} <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                value={citySearch}
                                onChange={(e) => setCitySearch(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleSearch();
                                    }
                                }}
                                placeholder={t('common.label.poblacion')}
                                required
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#006bc6] focus:border-transparent"
                            />
                        </div>
                        <div className="flex flex-col gap-2">
                            <label className="flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={searchDealerships}
                                    onChange={(e) => setSearchDealerships(e.target.checked)}
                                    className="w-4 h-4 text-[#006bc6] border-gray-300 rounded focus:ring-[#006bc6]"
                                />
                                <span className="ml-2 text-sm text-gray-700">{t('common.label.concesionarios')}</span>
                            </label>
                            <label className="flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={searchWorkshops}
                                    onChange={(e) => setSearchWorkshops(e.target.checked)}
                                    className="w-4 h-4 text-[#006bc6] border-gray-300 rounded focus:ring-[#006bc6]"
                                />
                                <span className="ml-2 text-sm text-gray-700">{t('common.label.talleres')}</span>
                            </label>
                            <label className="flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={searchSpareParts}
                                    onChange={(e) => setSearchSpareParts(e.target.checked)}
                                    className="w-4 h-4 text-[#006bc6] border-gray-300 rounded focus:ring-[#006bc6]"
                                />
                                <span className="ml-2 text-sm text-gray-700">{t('common.label.recambios')}</span>
                            </label>
                        </div>
                        <div className="flex flex-col gap-2">
                            <label className="flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={searchRentACar}
                                    onChange={(e) => setSearchRentACar(e.target.checked)}
                                    className="w-4 h-4 text-[#006bc6] border-gray-300 rounded focus:ring-[#006bc6]"
                                />
                                <span className="ml-2 text-sm text-gray-700">{t('common.label.rent-a-car')}</span>
                            </label>
                            <label className="flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={searchMotorcycleSales}
                                    onChange={(e) => setSearchMotorcycleSales(e.target.checked)}
                                    className="w-4 h-4 text-[#006bc6] border-gray-300 rounded focus:ring-[#006bc6]"
                                />
                                <span className="ml-2 text-sm text-gray-700">{t('common.label.venta-motos')}</span>
                            </label>
                        </div>
                        <div className="flex gap-2">
                            <Button
                                onClick={handleSearch}
                                label={t('common.label.lanzar-proceso')}
                            />
                            <Button
                                outlined
                                onClick={handleClearSearch}
                                label={t('common.button.reset')}
                            />
                        </div>
                    </div>
                </div>
                <div className='flex items-center justify-between mb-3 pt-4'>
                    <div className='text-[15px] font-semibold'>{t('common.label.ultimos-procesos')}</div>
                    <Button
                        onClick={() => {
                            const query = buildStatusQuery();
                            api(`/fleet/prospection-searches${query ? '?' + query : ''}`, 'GET');
                            setRefresh(Date.now().toString());
                        }}
                        label="common.label.actualizar"
                        variant="primary"
                    />
                </div>
                <div className="">
                    <div className="mb-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                        <div className="flex flex-wrap gap-4">
                            <label className="flex items-center cursor-pointer">
                                <input
                                    type="radio"
                                    name="statusFilter"
                                    value="ALL"
                                    checked={statusFilter === 'ALL'}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    className="w-4 h-4 text-[#006bc6] border-gray-300 focus:ring-[#006bc6]"
                                />
                                <span className="ml-2 text-sm font-medium text-gray-700">Todos</span>
                            </label>
                            <label className="flex items-center cursor-pointer">
                                <input
                                    type="radio"
                                    name="statusFilter"
                                    value="COMPLETED"
                                    checked={statusFilter === 'COMPLETED'}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    className="w-4 h-4 text-green-600 border-gray-300 focus:ring-green-500"
                                />
                                <span className="ml-2 text-sm font-medium text-gray-700">{t('common.label.completados')}</span>
                            </label>
                            <label className="flex items-center cursor-pointer">
                                <input
                                    type="radio"
                                    name="statusFilter"
                                    value="PENDING"
                                    checked={statusFilter === 'PENDING'}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    className="w-4 h-4 text-yellow-600 border-gray-300 focus:ring-yellow-500"
                                />
                                <span className="ml-2 text-sm font-medium text-gray-700">{t('common.label.pendientes')}</span>
                            </label>
                            <label className="flex items-center cursor-pointer">
                                <input
                                    type="radio"
                                    name="statusFilter"
                                    value="PROCESSING"
                                    checked={statusFilter === 'PROCESSING'}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                                />
                                <span className="ml-2 text-sm font-medium text-gray-700">{t('common.label.procesando')}</span>
                            </label>
                            <label className="flex items-center cursor-pointer">
                                <input
                                    type="radio"
                                    name="statusFilter"
                                    value="FAILED"
                                    checked={statusFilter === 'FAILED'}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    className="w-4 h-4 text-red-600 border-gray-300 focus:ring-red-500"
                                />
                                <span className="ml-2 text-sm font-medium text-gray-700">{t('common.label.fallidos')}</span>
                            </label>
                        </div>
                    </div>
                    <Table
                        path="/fleet/prospection-searches/"
                        query={buildStatusQuery()}
                        withPagination
                        noDelete
                        noEdit
                        noAction
                        refresh={refresh}
                        onRowClick={(item: any, index: number) => handleClick(item, index)}
                        selectedRowIndex={selectedIndexProspectionSearches}
                        headers={[
                            {
                                key: 'started_at',
                                type: 'date',
                                label: 'common.labels.date',
                            },
                            {
                                key: 'cities',
                                label: 'common.label.poblacion',
                            },
                            {
                                key: 'status',
                                label: 'common.form-label.tipo',
                            },
                        ]}
                    />
                </div>
                {(selectedProspectionSearches && selectedProspectionSearches.results && selectedProspectionSearches.results.length > 0) ? <div ref={resultsTableRef} className=' pt-12 pb-12'>
                    {/* Import button */}
                    <div className='flex justify-between items-center pb-4'>
                        <div className='text-[15px] font-semibold'>
                            {selectedRows.size > 0 ? `${selectedRows.size} ${t('common.label.seleccionados')}` : ''}
                        </div>
                        <div className='flex items-center gap-4'>
                            <label className="flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={deleteUnimported}
                                    onChange={(e) => setDeleteUnimported(e.target.checked)}
                                    className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-blue-500"
                                />
                                <span className="ml-2 text-sm font-medium text-gray-700">{t('common.label.borrar-prospectos-no-lista')}</span>
                            </label>
                            <Button
                                onClick={handleImport}
                                label={t('common.button.importar')}
                                disabled={selectedRows.size === 0}
                            />
                        </div>
                    </div>

                    <div className='overflow-y-auto border border-gray-200 rounded-md scrollable'>
                        <table className="w-full text-left">
                            <thead className="bg-gray-100 sticky top-0 z-10">
                                <tr className='bg-[#006bc6]'>
                                    <th className="py-3.5 pl-4 pr-3 text-center bg-transparent text-white sm:pl-6 not-italic text-xs leading-6 first:rounded-tl-lg w-12">
                                        <input
                                            type="checkbox"
                                            checked={selectedRows.size === selectedProspectionSearches?.results?.length && selectedRows.size > 0}
                                            onChange={handleSelectAll}
                                            className="w-4 h-4 text-primary border-gray-300 rounded focus:primary"
                                        />
                                    </th>
                                    <th className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6">{t('common.label.nombre')}</th>
                                    <th className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6">{t('common.label.poblacion')}</th>
                                    <th className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6">{t('common.label.direccion')}</th>
                                    <th className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6">{t('common.label.latitud')}</th>
                                    <th className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6">{t('common.label.longitud')}</th>
                                    <th className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6">{t('common.form-label.tipo')}</th>
                               
                                </tr>
                            </thead>
                            <tbody className='divide-y divide-gray-200 bg-white'>
                                {selectedProspectionSearches?.results?.map((item: any, index: any) => (
                                    <tr
                                        key={index}
                                        className={`p-8 hover:bg-blue-100 ${selectedRows.has(index) ? 'bg-blue-50' : ''}`}
                                    >
                                        <td className="text-center pl-4 pr-3 py-4">
                                            <input
                                                type="checkbox"
                                                checked={selectedRows.has(index)}
                                                onChange={() => handleRowSelect(index)}
                                                className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-blue-500"
                                            />
                                        </td>
                                        <td className="text-[12px] pl-[23px] py-4 text-black">{item.name}</td>
                                        <td className="text-[12px] pl-[23px] py-4 text-black">{item.city}</td>
                                        <td className="text-[12px] pl-[23px] py-4 text-black">{item.address}</td>
                                        <td className="text-[12px] pl-[23px] py-4 text-black">{item.lat}</td>
                                        <td className="text-[12px] pl-[23px] py-4 text-black">{item.lon}</td>
                                        <td className="text-[12px] pl-[23px] py-4 text-black">{item.business_type}</td>
                                      
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    
                    {/* Import Results Table */}
                    {importResults && importResults.details && importResults.details.length > 0 && (
                        <div ref={importResultsTableRef} className='pt-8'>
                            <div className='flex justify-between items-center pb-4'>
                                <div className='text-[15px] font-semibold'>{t('common.label.resultados-importacion')}</div>
                                <div className='text-sm text-gray-600'>
                                    <span className='font-medium text-green-600'>{importResults.imported_count} {t('common.label.importados')}</span>
                                    {importResults.skipped_count > 0 && <span className='ml-3 font-medium text-yellow-600'>{importResults.skipped_count} {t('common.label.omitidos')}</span>}
                                    {importResults.deactivated_count > 0 && <span className='ml-3 font-medium text-red-600'>{importResults.deactivated_count} {t('common.label.desactivados')}</span>}
                                </div>
                            </div>
                            
                            <div className='overflow-y-auto border border-gray-200 rounded-md scrollable max-h-96'>
                                <table className="w-full text-left">
                                    <thead className="bg-gray-100 sticky top-0 z-10">
                                        <tr className='bg-[#006bc6]'>
                                            <th className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6 first:rounded-tl-lg">{t('common.label.nombre')}</th>
                                            <th className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6">{t('common.label.poblacion')}</th>
                                            <th className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6">{t('common.label.direccion')}</th>
                                            <th className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6">{t('common.label.latitud')}</th>
                                            <th className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6">{t('common.label.longitud')}</th>
                                            <th className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6">{t('common.form-label.tipo')}</th>
                                            <th className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6">{t('common.label.estado')}</th>
                                        </tr>
                                    </thead>
                                    <tbody className='divide-y divide-gray-200 bg-white'>
                                        {importResults.details.map((item: any, index: any) => (
                                            <tr
                                                key={index}
                                                className={`p-8 hover:bg-gray-50`}
                                            >
                                                <td className="text-[12px] pl-[23px] py-4 text-black">{item.name}</td>
                                                <td className="text-[12px] pl-[23px] py-4 text-black">{item.city}</td>
                                                <td className="text-[12px] pl-[23px] py-4 text-black">{item.address}</td>
                                                <td className="text-[12px] pl-[23px] py-4 text-black">{item.lat}</td>
                                                <td className="text-[12px] pl-[23px] py-4 text-black">{item.lon}</td>
                                                <td className="text-[12px] pl-[23px] py-4 text-black">{item.business_type}</td>
                                                <td className="text-[12px] pl-[23px] py-4">
                                                    <span className={`px-2 py-1 rounded text-xs font-medium ${
                                                        item.status === 'imported' ? 'bg-green-100 text-green-800' :
                                                        item.status === 'skipped' ? 'bg-yellow-100 text-yellow-800' :
                                                        'bg-red-100 text-red-800'
                                                    }`}>
                                                        {item.status === 'imported' ? t('common.label.importado') :
                                                         item.status === 'skipped' ? t('common.label.omitido') :
                                                         t('common.label.desactivado')}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div> : ''}
            </>
        </PageBody>
    );
};
